export const appurl = 'https://mm2jdgganf.execute-api.us-east-1.amazonaws.com/qa';
export const service = `${appurl}/serviceregion`;
export const services = `${appurl}/servicesregion`;
export const sharedservices = `${appurl}/sharedservices`;
export const servicehistory = `${appurl}/historyservice`;

